import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, GraduationCap, Award, ChevronRight, Activity, Zap, Target, Move, Gauge, ShieldCheck } from 'lucide-react';
export function About() {
  return <div className="w-full" data-id="element-93" data-mp="29kyf5n2psq8d">
      <SplitHero data-id="element-94" data-mp="29hiy4ephd74b" />
      <StatsBand data-id="element-95" data-mp="2eiq5icnpo4ag" />
      <BioNarrative data-id="element-96" data-mp="2ei6snacx463a" />
      <CredentialsStrip data-id="element-97" data-mp="2ejhyrgtu5pxk" />
      <Philosophy data-id="element-98" data-mp="2eizxu6w8anjb" />
      <Specialties data-id="element-99" data-mp="328azdqleklyi" />
      <SportsLevels data-id="element-100" data-mp="327rh28rubvjy" />
      <MidCta data-id="element-101" data-mp="329cd62tszmjx" />
      <Facility data-id="element-102" data-mp="328u6sddffrya" />
      <FinalCta data-id="element-103" data-mp="3267zmeug7egl" />
    </div>;
}
/* ---------- MID-PAGE CTA ---------- */
function MidCta() {
  return <section className="bg-reach-red" data-id="element-104" data-mp="375b33uus5cmg">
      <div className="max-w-container mx-auto px-4 md:px-8 py-10 md:py-12 flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left" data-id="element-105" data-mp="2samui7u31y2m">
        <div data-id="element-106" data-mp="2xb10lkc4ixy0">
          <p className="font-bebas text-white text-3xl md:text-4xl tracking-wide leading-none mb-1" data-id="element-107" data-mp="1guy75fcx2x1a">
            Train with Reach.
          </p>
          <p className="font-inter text-white/90 text-sm md:text-base uppercase tracking-[0.2em]" data-id="element-108" data-mp="1luu793ihu4bk">
            Start with a free 15-minute consultation.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 shrink-0 w-full sm:w-auto" data-id="element-109" data-mp="1pjgwavueuov8">
          <Link to="/book" className="inline-flex items-center justify-center bg-white text-reach-black font-inter font-semibold px-6 min-h-[44px] md:min-h-[48px] rounded-[4px] transition-all duration-200 ease-out hover:bg-reach-black hover:text-white uppercase tracking-wide text-sm hover:-translate-y-[3px]" data-id="element-110" data-mp="23izq0jmh5xo0">
            Book Consultation
          </Link>
          <Link to="/pricing" className="btn-secondary-dark sm:w-auto" data-id="element-111" data-mp="2m8puxzjybztn">
            See Pricing
          </Link>
        </div>
      </div>
    </section>;
}
/* ---------- BIO NARRATIVE ---------- */
function BioNarrative() {
  return <section className="bg-white py-20 md:py-28" data-id="element-112" data-mp="2w7x92oyifyht">
      <div className="max-w-3xl mx-auto px-4 md:px-8" data-id="element-113" data-mp="2r82iynmk7cxt">
        <div className="text-center mb-12" data-id="element-114" data-mp="2r9lyud4azlz2">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-115" data-mp="1oumtm5tlm6re">
            Background
          </p>
          <h2 className="font-bebas text-5xl md:text-6xl tracking-wide leading-none" data-id="element-116" data-mp="1sx1a4j9soufi">
            The Story
          </h2>
          <div className="w-12 h-1 bg-reach-red mt-6 mx-auto" data-id="element-117" data-mp="1xu0491tgl1dp" />
        </div>

        <div className="space-y-6 font-inter text-reach-black text-base md:text-lg leading-[1.75]" data-id="element-118" data-mp="22mt8lol0m7p9">
          <p data-id="element-119" data-mp="27kclol5z8efm">
            <span className="float-left font-bebas text-reach-red text-[72px] leading-[0.85] mr-3 mt-1" data-id="element-120" data-mp="27kupc2uyxuxk">
              F
            </span>
            ernando Beltran is the Owner and Director of Performance at Reach
            Performance, operating in the Dallas–Fort Worth area. He holds a
            Bachelor's Degree in Exercise Science from North Park University and
            a Master's Degree in Business Administration, with nearly a decade
            in strength and conditioning across the youth, high school,
            collegiate, and professional levels.
          </p>

          <p data-id="element-121" data-mp="joy0t593v0c5">
            Before founding Reach, he built his coaching foundation inside
            collegiate strength and conditioning environments:{' '}
            <span className="font-semibold" data-id="element-122" data-mp="9x0mvqqppu9q">
              Northwestern University Football
            </span>{' '}
            (NCAA Division I),{' '}
            <span className="font-semibold" data-id="element-123" data-mp="50a6t3ewqyob">North Park University</span> (NCAA
            Division III), and{' '}
            <span className="font-semibold" data-id="element-124" data-mp="12k4tg05gegnm">Florida Memorial University</span>{' '}
            (NAIA), sharpening an approach grounded in performance training,
            athlete development, and speed-based programming.
          </p>

          {/* Pull quote */}
          <blockquote className="my-10 border-l-4 border-reach-red bg-reach-gray pl-6 pr-5 py-6 rounded-r-[4px]" data-id="element-125" data-mp="olog3qd35rwi">
            <p className="font-bebas text-reach-black text-2xl md:text-3xl tracking-wide leading-tight" data-id="element-126" data-mp="3dflkg2s2mxoh">
              Hundreds of athletes coached, from youth players in their first
              season to professionals competing in the{' '}
              <span className="text-reach-red" data-id="element-127" data-mp="15ufn4ydilw4i">MLB, NFL, NBA</span>, and pro
              soccer.
            </p>
          </blockquote>

          <p data-id="element-128" data-mp="r7498ptv2018">
            The philosophy combines evidence-based principles with practical
            application. Areas of focus include{' '}
            <span className="font-semibold" data-id="element-129" data-mp="w2jpfofcc80t">
              speed development, power training, movement efficiency, and force
              production
            </span>
            , with an emphasis on acceleration mechanics, multidirectional
            speed, strength, deceleration control, and movement quality to build
            explosive, resilient athletes.
          </p>

          <p data-id="element-130" data-mp="1exgs2vqn9h6l">
            Every program also integrates{' '}
            <span className="font-semibold" data-id="element-131" data-mp="3viyccuy7kst5">
              athlete monitoring, performance testing, and data-driven
              evaluation
            </span>{' '}
            to individualize training and track development over time. The goal:
            an elite environment that develops athletes physically and mentally,
            preparing them for long-term success in sport, and beyond it.
          </p>
        </div>
      </div>
    </section>;
}
/* ---------- SPLIT HERO ---------- */
function SplitHero() {
  return <section className="bg-white" data-id="element-132" data-mp="wka4ird7ulv">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px] lg:min-h-[680px]" data-id="element-133" data-mp="39bch4xkbwrnb">
        <div className="relative bg-reach-black overflow-hidden order-2 lg:order-1 min-h-[400px] lg:min-h-0" data-id="element-134" data-mp="34cj39414qymm">
          <img src="https://images.unsplash.com/photo-1599058917212-d750089bc07e?q=80&w=1600&auto=format&fit=crop" alt="Fernando Beltran coaching an athlete" className="absolute inset-0 w-full h-full object-cover photo-editorial" data-id="element-135" data-mp="3j15ht3ixnmcs" />
          <div className="absolute inset-0 bg-gradient-to-tr from-black/55 via-transparent to-black/20" data-id="element-136" data-mp="2qirqznw0l0n7" />
          <div className="absolute inset-0 bg-reach-red mix-blend-multiply opacity-[0.08]" data-id="element-137" data-mp="3ba5e44l92nm4" />

          <div className="absolute bottom-12 -left-10 w-[55%] h-1.5 bg-reach-red rotate-[8deg] opacity-70" data-id="element-138" data-mp="3b8cg1dopdbpq" />
          <div className="absolute bottom-8 -left-10 w-[40%] h-1.5 bg-reach-red rotate-[8deg] opacity-40" data-id="element-139" data-mp="3k2h27jsw5yyx" />
          <div className="absolute bottom-4 -left-10 w-[28%] h-1.5 bg-reach-red rotate-[8deg] opacity-25" data-id="element-140" data-mp="3p1agvfjwzw0o" />

          <div className="absolute bottom-6 left-6 right-6 lg:bottom-10 lg:left-10 lg:right-10 z-10" data-id="element-141" data-mp="2sbt28b2yezmu">
            <p className="font-inter text-white/80 text-xs uppercase tracking-[0.3em] font-semibold" data-id="element-142" data-mp="2wcd39pqnene9">
              On the floor · INPOWERiQ
            </p>
          </div>
        </div>

        <div className="flex flex-col justify-center px-6 md:px-12 lg:px-16 py-16 lg:py-0 order-1 lg:order-2" data-id="element-143" data-mp="36asudspodwnr">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-4" data-id="element-144" data-mp="gma2tphienvy">
            Owner · Director of Performance
          </p>
          <h1 className="font-bebas text-reach-black text-6xl md:text-7xl lg:text-[96px] leading-[0.9] tracking-wide mb-6" data-id="element-145" data-mp="lmo9b33gpprv">
            Fernando
            <br data-id="element-146" data-mp="214u9mz0ku906" />
            Beltran
          </h1>

          <div className="w-12 h-1 bg-reach-red mb-6" data-id="element-147" data-mp="2165el25rdmsv" />

          <div className="space-y-4 font-inter text-reach-black text-base md:text-lg leading-relaxed max-w-xl" data-id="element-148" data-mp="1wbrp1gds29w4">
            <p data-id="element-149" data-mp="1rdgdn17u3rbs">
              Built to give Dallas–Fort Worth athletes a true performance
              environment. Structured, measurable, and grounded in the science
              of how athletes actually develop.
            </p>
            <p data-id="element-150" data-mp="1de8do63ukf6j">
              Nearly a decade in strength and conditioning, with coaching
              experience across youth, high school, collegiate, and professional
              levels.
            </p>
            <p className="font-bebas text-reach-red text-2xl md:text-3xl tracking-wide pt-2" data-id="element-151" data-mp="37rzjsvmywgx8">
              "Every day has a purpose."
            </p>
          </div>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:items-center text-sm" data-id="element-152" data-mp="32ty4mlsnx1r1">
            <a href="mailto:Fernando@reachperformancehq.com" className="inline-flex items-center gap-2 font-inter font-semibold uppercase tracking-wider text-reach-black hover:text-reach-red transition-colors" data-id="element-153" data-mp="2boc58kj9p9jj">
              <Mail size={16} className="text-reach-red" data-id="element-154" data-mp="26wkdw7saezsc" />
              Email Fernando
            </a>
            <span className="hidden sm:inline text-reach-black/30" data-id="element-155" data-mp="1swrruprph7qp">·</span>
            <a href="tel:7089804666" className="inline-flex items-center gap-2 font-inter font-semibold uppercase tracking-wider text-reach-black hover:text-reach-red transition-colors" data-id="element-156" data-mp="1xwe4awzpmjyg">
              <Phone size={16} className="text-reach-red" data-id="element-157" data-mp="1nxg95b7s3s6h" />
              (708) 980-4666
            </a>
          </div>
        </div>
      </div>
    </section>;
}
/* ---------- CREDENTIALS STRIP ---------- */
function CredentialsStrip() {
  return <section className="bg-reach-black text-white py-16 md:py-20 relative overflow-hidden" data-id="element-158" data-mp="3ia4zooz11dwk">
      <div className="absolute -right-40 top-1/4 w-[40%] h-1 bg-reach-red opacity-30 rotate-[5deg]" data-id="element-159" data-mp="16p5jdqotfa2x" />
      <div className="absolute -right-40 top-[34%] w-[28%] h-1 bg-reach-red opacity-20 rotate-[5deg]" data-id="element-160" data-mp="12l7jvevkvx9c" />

      <div className="max-w-container mx-auto px-4 md:px-8 relative" data-id="element-161" data-mp="1ggs4ceqygniv">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-16" data-id="element-162" data-mp="1bn756jdmlni3">
          {/* Education */}
          <div data-id="element-163" data-mp="1qbblxht4boy8">
            <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-4 flex items-center gap-2" data-id="element-164" data-mp="1qezhsnm1cng4">
              <GraduationCap size={16} data-id="element-165" data-mp="1zdb44dfvcz2r" />
              Education
            </p>
            <ul className="space-y-4" data-id="element-166" data-mp="1zb72y39cue66">
              <li className="border-l-2 border-reach-red pl-4" data-id="element-167" data-mp="1ue8bjsh2slbo">
                <p className="font-bebas text-2xl tracking-wide leading-none mb-1" data-id="element-168" data-mp="4zjzjsced5e6">
                  Master of Business Administration
                </p>
                <p className="font-inter text-sm text-white/70 uppercase tracking-wider" data-id="element-169" data-mp="209lv6c746e">
                  MBA
                </p>
              </li>
              <li className="border-l-2 border-white/20 pl-4" data-id="element-170" data-mp="37f67220m07b0">
                <p className="font-bebas text-2xl tracking-wide leading-none mb-1" data-id="element-171" data-mp="37dldaem4cse7">
                  Bachelor of Science, Exercise Science
                </p>
                <p className="font-inter text-sm text-white/70 uppercase tracking-wider" data-id="element-172" data-mp="2yezzsxvi83ka">
                  North Park University
                </p>
              </li>
            </ul>
          </div>

          {/* Coaching Background */}
          <div data-id="element-173" data-mp="3r3p04uoqk4uz">
            <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-4 flex items-center gap-2" data-id="element-174" data-mp="3r59mhx0wchhr">
              <Award size={16} data-id="element-175" data-mp="3hdlwm0jzn8ie" />
              Coaching Background
            </p>
            <ul className="space-y-4" data-id="element-176" data-mp="imtxngbuomhf">
              <li className="border-l-2 border-reach-red pl-4" data-id="element-177" data-mp="invmcnlsh7hm">
                <p className="font-bebas text-xl tracking-wide leading-none mb-1" data-id="element-178" data-mp="dwn8nfdfezyn">
                  Northwestern University Football
                </p>
                <p className="font-inter text-sm text-white/70 uppercase tracking-wider" data-id="element-179" data-mp="l9csiqo79xn6">
                  NCAA Division I
                </p>
              </li>
              <li className="border-l-2 border-white/20 pl-4" data-id="element-180" data-mp="v5g2ujt7h2l7">
                <p className="font-bebas text-xl tracking-wide leading-none mb-1" data-id="element-181" data-mp="z7b4jpf1thzi">
                  North Park University
                </p>
                <p className="font-inter text-sm text-white/70 uppercase tracking-wider" data-id="element-182" data-mp="145cp6es4hpd3">
                  NCAA Division III
                </p>
              </li>
              <li className="border-l-2 border-white/20 pl-4" data-id="element-183" data-mp="1dwfnx9xkxs97">
                <p className="font-bebas text-xl tracking-wide leading-none mb-1" data-id="element-184" data-mp="1dwz52ofeocm6">
                  Florida Memorial University
                </p>
                <p className="font-inter text-sm text-white/70 uppercase tracking-wider" data-id="element-185" data-mp="1mxdt3vjr85td">
                  NAIA
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}
/* ---------- PHILOSOPHY ---------- */
function Philosophy() {
  return <section className="bg-reach-gray py-20 md:py-28" data-id="element-186" data-mp="3jy1j6n4q8hmp">
      <div className="max-w-3xl mx-auto px-4 md:px-8" data-id="element-187" data-mp="3jvf1vvs1anra">
        <div className="text-center mb-12" data-id="element-188" data-mp="1jseoe6o0d0d">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-189" data-mp="1llkxsdd8v7u">
            The Philosophy
          </p>
          <h2 className="font-bebas text-5xl md:text-6xl tracking-wide leading-none" data-id="element-190" data-mp="bgx18f4faahp">
            Why We Exist
          </h2>
        </div>

        <div className="space-y-6 font-inter text-reach-black text-lg leading-relaxed" data-id="element-191" data-mp="6ic08dhcjms7">
          <p data-id="element-192" data-mp="khuvi5p273n3">
            Reach Performance combines evidence-based training principles with
            practical application that directly transfers to sport. No random
            workouts. No cookie-cutter programs. Every athlete gets training
            that matches their sport, position, and stage of development.
          </p>
          <p data-id="element-193" data-mp="wsm5glvof0wl">
            Programming is periodized. Each week, each block, each season has a
            specific purpose. Group sizes are capped at eight so every athlete
            gets coached, not just counted. Performance testing happens every
            four weeks so progress is real, measured, and undeniable.
          </p>
          <p data-id="element-194" data-mp="s143buhx2ua1">
            Athletes leave the floor knowing exactly why they did what they did,
            and how it makes them better on the field, the court, or the mound.
          </p>
        </div>
      </div>
    </section>;
}
/* ---------- SPECIALTIES ---------- */
const SPECIALTIES = [{
  Icon: Zap,
  title: 'Speed Development',
  body: 'Acceleration mechanics, top-end speed, and sprint patterning.'
}, {
  Icon: Target,
  title: 'Power Training',
  body: 'Explosive force expression: jumps, throws, change of direction.'
}, {
  Icon: Move,
  title: 'Multidirectional Speed',
  body: 'Lateral mechanics, cut technique, and reactive agility.'
}, {
  Icon: ShieldCheck,
  title: 'Deceleration Control',
  body: 'Braking force, joint integrity, and injury resilience.'
}, {
  Icon: Gauge,
  title: 'Force Production',
  body: 'Strength under load with transfer to sport-specific output.'
}, {
  Icon: Activity,
  title: 'Movement Quality',
  body: 'Mechanics, positions, and movement efficiency that hold up under fatigue.'
}];
function Specialties() {
  return <section className="bg-white py-20 md:py-28" data-id="element-195" data-mp="vsve1qsdvz67">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-196" data-mp="r0apb3oc4c9j">
        <div className="text-center mb-14" data-id="element-197" data-mp="qyzj6x7f2sf9">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-198" data-mp="m0xx03ep2czk">
            Areas of Focus
          </p>
          <h2 className="font-bebas text-4xl md:text-6xl tracking-wide leading-none" data-id="element-199" data-mp="h0jsgvcaxl6a">
            What We Train
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-id="element-200" data-mp="81g9drd4x5rs">
          {SPECIALTIES.map(({
          Icon,
          title,
          body
        }) => <div key={title} className="group bg-reach-gray rounded-[4px] p-7 md:p-8 border-b-4 border-transparent hover:border-reach-red hover:-translate-y-1 transition-all duration-200 ease-out flex flex-col" data-id="element-201" data-mp="2jp1wgn2exl2l">
              <div className="w-11 h-11 bg-reach-black rounded-[4px] flex items-center justify-center mb-5" data-id="element-202" data-mp="2xpcmjnvwevmp">
                <Icon size={20} className="text-reach-red" data-id="element-203" data-mp="202dmd35zz5k2" />
              </div>
              <h3 className="font-bebas text-2xl tracking-wide uppercase leading-none mb-3" data-id="element-204" data-mp="24zvw2vru9ot4">
                {title}
              </h3>
              <p className="font-inter text-reach-black/80 text-base leading-relaxed" data-id="element-205" data-mp="29xxfjht6fq54">
                {body}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}
/* ---------- SPORTS & LEVELS ---------- */
const SPORTS = ['Football', 'Baseball', 'Basketball', 'Soccer', 'Volleyball', 'Golf', 'Tennis'];
const LEVELS = [{
  label: 'Youth',
  sub: 'Ages 8–10'
}, {
  label: 'Middle School',
  sub: 'Ages 11–13'
}, {
  label: 'High School',
  sub: 'Varsity & Recruiting'
}, {
  label: 'Collegiate',
  sub: 'NCAA · NAIA'
}, {
  label: 'Professional',
  sub: 'MLB · NFL · NBA · Pro Soccer'
}];
function SportsLevels() {
  return <section className="bg-reach-black text-white py-20 md:py-28 relative overflow-hidden" data-id="element-206" data-mp="1j219cw70mg6q">
      <div className="absolute top-0 -left-20 w-[35%] h-1 bg-reach-red rotate-[4deg] opacity-40" data-id="element-207" data-mp="vcggnll284k9" />
      <div className="absolute bottom-12 -right-20 w-[35%] h-1 bg-reach-red rotate-[4deg] opacity-40" data-id="element-208" data-mp="rav8gdjh0ege" />

      <div className="max-w-container mx-auto px-4 md:px-8 relative" data-id="element-209" data-mp="156gvwga22q6p">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20" data-id="element-210" data-mp="107vre4nrtkcg">
          {/* Sports */}
          <div data-id="element-211" data-mp="2gm5fcxo3p72r">
            <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-212" data-mp="2gptb83h0q5kn">
              Sports Trained
            </p>
            <h2 className="font-bebas text-4xl md:text-5xl tracking-wide leading-none mb-8" data-id="element-213" data-mp="3tlz6ilkctn75">
              Sport-Agnostic. <br data-id="element-214" data-mp="2h0gi4b161ti" />
              <span className="text-reach-red" data-id="element-215" data-mp="2himvtrepwf5">Sport-Specific.</span>
            </h2>
            <div className="flex flex-wrap gap-2.5" data-id="element-216" data-mp="3kmvnfhl6t7sn">
              {SPORTS.map(s => <span key={s} className="inline-flex items-center px-4 py-2 border border-white/20 rounded-[4px] font-inter text-sm uppercase tracking-wider hover:border-reach-red hover:text-reach-red transition-colors" data-id="element-217" data-mp="3plop8cr43acz">
                  {s}
                </span>)}
            </div>
            <p className="font-inter text-white/70 text-sm mt-6 leading-relaxed max-w-md" data-id="element-218" data-mp="7d7o01j2rldk">
              Across all seven sports, from first-year players to starters
              competing on the biggest stages.
            </p>
          </div>

          {/* Levels */}
          <div data-id="element-219" data-mp="14vzg8gd3ais7">
            <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-220" data-mp="14wiwztr0714n">
              Levels of Experience
            </p>
            <h2 className="font-bebas text-4xl md:text-5xl tracking-wide leading-none mb-8" data-id="element-221" data-mp="2w5t3k2mruwe0">
              Youth to Pro.
            </h2>
            <ul className="space-y-3" data-id="element-222" data-mp="2r5oomh1ii9pw">
              {LEVELS.map(l => <li key={l.label} className="flex items-center justify-between gap-4 border-b border-white/10 pb-3" data-id="element-223" data-mp="2ma9bjrbbwhuj">
                  <div className="flex items-center gap-3" data-id="element-224" data-mp="3ex2hco3ks7be">
                    <ChevronRight size={16} className="text-reach-red shrink-0" data-id="element-225" data-mp="3evj12xhx5w9m" />
                    <span className="font-bebas text-xl tracking-wider uppercase" data-id="element-226" data-mp="35vm66e4xs164">
                      {l.label}
                    </span>
                  </div>
                  <span className="font-inter text-xs uppercase tracking-[0.2em] text-white/60 text-right" data-id="element-227" data-mp="1uhqpv22apmdb">
                    {l.sub}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}
/* ---------- FACILITY ---------- */
function Facility() {
  const photos = [{
    src: 'https://images.unsplash.com/photo-1540497077202-7c8a3999166f?q=80&w=1200&auto=format&fit=crop',
    alt: 'Indoor training turf with speed gates',
    caption: 'Indoor Turf'
  }, {
    src: 'https://images.unsplash.com/photo-1534438097545-a31885568541?q=80&w=1200&auto=format&fit=crop',
    alt: 'Strength and conditioning equipment',
    caption: 'Strength Floor'
  }, {
    src: 'https://images.unsplash.com/photo-1545205597-3d9d02c29597?q=80&w=1200&auto=format&fit=crop',
    alt: 'On-site recovery zone',
    caption: 'Recovery Zone'
  }];
  return <section className="bg-white py-20 md:py-28" data-id="element-228" data-mp="33jk17q5y4uny">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-229" data-mp="38gk4jtbevjbd">
        <div className="text-center mb-12" data-id="element-230" data-mp="38j6bprue3wt2">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-231" data-mp="2saveign6ivyt">
            The Facility
          </p>
          <h2 className="font-bebas text-4xl md:text-6xl tracking-wide leading-none" data-id="element-232" data-mp="2x9pwjgdboghv">
            INPOWERiQ Performance Center
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-12" data-id="element-233" data-mp="36zhu8jgpxpqk">
          {photos.map(p => <figure key={p.caption} className="group relative aspect-[4/5] bg-reach-black rounded-[4px] overflow-hidden" data-id="element-234" data-mp="3aztg1zkthw3m">
              <img src={p.src} alt={p.alt} className="absolute inset-0 w-full h-full object-cover photo-editorial transition-transform duration-500 group-hover:scale-105" data-id="element-235" data-mp="3kzahg4t1dnts" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" data-id="element-236" data-mp="1qm1gj1ek3an5" />
              <div className="absolute top-4 left-4 w-10 h-1 bg-reach-red" data-id="element-237" data-mp="1vkvyk14p8v67" />
              <figcaption className="absolute bottom-5 left-5 right-5" data-id="element-238" data-mp="cp873dufzfbd">
                <p className="font-bebas text-white text-2xl md:text-3xl tracking-wide leading-none" data-id="element-239" data-mp="7y9na4a8vz3d">
                  {p.caption}
                </p>
              </figcaption>
            </figure>)}
        </div>

        <p className="font-inter text-reach-black text-lg md:text-xl leading-relaxed text-center max-w-3xl mx-auto" data-id="element-240" data-mp="3v3qy30ecb8yn">
          24,000 sq ft. Speed gates. Indoor turf. On-site recovery. Athlete
          monitoring and performance testing built into every program.
        </p>

        <div className="text-center mt-8" data-id="element-241" data-mp="mmw3073sasv4">
          <a href="https://maps.google.com/?q=6051+Alma+Rd,+McKinney,+TX+75070" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-inter font-semibold uppercase tracking-wider text-sm text-reach-black hover:text-reach-red transition-colors" data-id="element-242" data-mp="mlupzx37jwar">
            6051 Alma Rd · McKinney, TX 75070
            <span className="text-reach-red" data-id="element-243" data-mp="33wiourct5niy">→</span>
          </a>
        </div>
      </div>
    </section>;
}
/* ---------- STATS BAND ---------- */
function StatsBand() {
  const stats = [{
    num: '10 yrs',
    label: 'Coaching experience'
  }, {
    num: '500+',
    label: 'Athletes coached'
  }, {
    num: '4',
    label: 'Pro leagues represented'
  }, {
    num: '7',
    label: 'Sports specialized'
  }];
  return <section className="bg-reach-gray py-16 md:py-20 relative overflow-hidden border-y border-black/5" data-id="element-244" data-mp="2pvencc9f4zad">
      <div className="max-w-container mx-auto px-4 md:px-8 relative" data-id="element-245" data-mp="2c4tbh7idtplz">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-10 gap-x-6" data-id="element-246" data-mp="2c2glc72h08xu">
          {stats.map((s, i) => <div key={s.label} className={`text-center lg:text-left ${i !== 0 ? 'lg:border-l lg:border-black/10 lg:pl-6' : ''}`} data-id="element-247" data-mp="2263q34ra1n0z" data-mpi={i}>
              <p className="font-bebas text-reach-red text-5xl md:text-6xl lg:text-7xl leading-none mb-3 tracking-wide" data-id="element-248" data-mp="2779mbck5bsf9">
                {s.num}
              </p>
              <p className="font-inter text-reach-black/80 text-xs md:text-sm uppercase tracking-[0.2em]" data-id="element-249" data-mp="1ildamquwbqnc">
                {s.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}
/* ---------- FINAL CTA ---------- */
function FinalCta() {
  return <section className="bg-reach-red py-16 md:py-20" data-id="element-250" data-mp="26hhgrl1b7ctz">
      <div className="max-w-container mx-auto px-4 md:px-8 text-center" data-id="element-251" data-mp="26fwk9pvfpjth">
        <h2 className="font-bebas text-white text-5xl md:text-7xl tracking-wide mb-4" data-id="element-252" data-mp="21iwbv8b444z7">
          Train With Purpose.
        </h2>
        <p className="font-inter text-white text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-253" data-mp="2b8zf01by6zb9">
          Book a free 15-minute consultation to find the right program for your
          athlete.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-stretch sm:items-center max-w-md sm:max-w-none mx-auto" data-id="element-254" data-mp="2l75g4gpxk1f2">
          <Link to="/pricing" className="inline-flex items-center justify-center bg-white text-reach-black font-inter font-semibold px-6 min-h-[44px] md:min-h-[48px] rounded-[4px] transition-all duration-200 ease-out hover:bg-reach-black hover:text-white uppercase tracking-wide text-sm md:text-base hover:-translate-y-[3px]" data-id="element-255" data-mp="il9rhasyblbj">
            Enroll Now
          </Link>
          <Link to="/book" className="btn-secondary-dark sm:w-auto" data-id="element-256" data-mp="3vs1u55uycp3r">
            Book Free Consultation
          </Link>
        </div>
      </div>
    </section>;
}